exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".p-user-reservation .table td[data-v-0c6e0e74],.p-user-reservation .table th[data-v-0c6e0e74]{font-size:.8rem}span.is-invalid[data-v-0c6e0e74]{position:relative;left:2px;color:#dc3545}", ""]);

// exports
